"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../@hooks/index");
var _store = require("../@api/store");
var _dokdriveApi = _interopRequireDefault(require("../@apis/dokdriveApi"));
var _appcenter = _interopRequireWildcard(require("../@api/appcenter"));
var _dokia = require("../@api/dokia");
var _CelebrationMessages = _interopRequireDefault(require("./Messages/CelebrationMessages"));
var _Message = _interopRequireDefault(require("./Message"));
var _TimeBlockingMessage = _interopRequireDefault(require("./TimeBlockingMessage"));
var _SecurityRequirementAlert = _interopRequireDefault(require("./SecurityRequirementAlert"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var appcenterFirestore = _appcenter.firebase.firestore();
var dokiaFirestore = _dokia.firebaseNewton.firestore();
var userCollection = appcenterFirestore.collection('user');
var dokdriveInstallerCollection = dokiaFirestore.collection('dokdriveInstaller');

// const createScript = ({ id, src, async = false, defer = false }) => {
// 	const script = document.createElement('script')
// 	script.id = id
// 	script.src = src
// 	script.async = async
// 	script.defer = defer
// 	return script
// }

// const addScript = ({ id, src, async = false, defer = false }) => {
// 	const script = createScript({ id, src, async, defer })
// 	const existingScript = document.querySelector(`#${id}`)
// 	console.log('existingScript', existingScript)
// 	if (existingScript) return
// 	document.body.appendChild(script)
// }

function Scripts(_ref) {
  var app = _ref.app,
    children = _ref.children;
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    storeState = _useState2[0],
    setStoreState = _useState2[1];
  var auth = storeState.appcenter;
  // const { loading, whitelabel, whitelabelLicense } = useWhitelabel()
  var _useState3 = (0, _react.useState)({
      visible: false,
      title: '',
      description: ''
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    message = _useState4[0],
    setMessage = _useState4[1];

  // const ideaSuggestionsScript = {
  // 	id: 'userreport-launcher-script',
  // 	src: `https://sak.userreport.com/${app === 'appcenter-customer' ? 'appcentercrm' : app === 'dokia' ? 'taugor' : app}/launcher.js`,
  // 	async: true
  // }

  // const botScript = {
  // 	id: 'dt-widget',
  // 	src: 'https://www5.directtalk.com.br/clientes/custom/Taugor_1/widget.min.js'
  // }

  // const appWhitelabel = whitelabel ? whitelabel[app] : undefined

  // useEffect(() => {
  // 	console.log('loading', loading)
  // 	if (loading) return

  // 	console.log('whitelabelLicense', whitelabelLicense)
  // 	console.log('appWhitelabel', appWhitelabel)
  // 	console.log('whitelabel', whitelabel)

  // 	if (!whitelabel) return

  // 	const licenseIsEnabled = !!whitelabelLicense && ['paid', 'free'].includes(whitelabelLicense.status)

  // 	if (appWhitelabel?.hideBot && licenseIsEnabled) {
  // 		const dtWidget = document.querySelector(`#${botScript.id}`)
  // 		if (dtWidget) dtWidget.remove()
  // 	} else {
  // 		addScript({ ...botScript })
  // 	}

  // 	if (appWhitelabel?.hideIdeaSuggestions && licenseIsEnabled) {
  // 		const userReport = document.querySelector(`#${ideaSuggestionsScript.id}`)
  // 		if (userReport) userReport.remove()
  // 	} else {
  // 		addScript({ ...ideaSuggestionsScript })
  // 	}
  // }, [loading])

  (0, _index.useInterval)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(id) {
      var licenses, timeBlockingLicense, company, timeBlockingConfig, appTimeBlocking, startTime, endTime, timeZone, todayTime, isUnderAllowedTime, _startTime, startHour, startMinute, _endTime, endHour, endMinute;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (auth !== null && auth !== void 0 && auth.isAuthContextCreated) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", clearInterval(id));
          case 2:
            if (auth.authenticated) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", clearInterval(id));
          case 4:
            licenses = (auth === null || auth === void 0 ? void 0 : auth.licenses) || [];
            timeBlockingLicense = licenses.find(function (license) {
              return license.app === app && license.type === 'time-blocking' && !license.deleted;
            });
            if (timeBlockingLicense) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", clearInterval(id));
          case 8:
            if (['paid', 'free'].includes(timeBlockingLicense.status)) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", clearInterval(id));
          case 10:
            company = (auth === null || auth === void 0 ? void 0 : auth.company) || {};
            if (company !== null && company !== void 0 && company.uid) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return", clearInterval(id));
          case 13:
            timeBlockingConfig = company.timeBlocking;
            if (timeBlockingConfig) {
              _context.next = 16;
              break;
            }
            return _context.abrupt("return", clearInterval(id));
          case 16:
            appTimeBlocking = timeBlockingConfig[app];
            if (appTimeBlocking) {
              _context.next = 19;
              break;
            }
            return _context.abrupt("return", clearInterval(id));
          case 19:
            if (appTimeBlocking.enabled) {
              _context.next = 21;
              break;
            }
            return _context.abrupt("return", clearInterval(id));
          case 21:
            startTime = appTimeBlocking.startTime, endTime = appTimeBlocking.endTime, timeZone = appTimeBlocking.timeZone;
            todayTime = new Date().toLocaleTimeString('pt-BR', {
              timeZone: timeZone
            });
            isUnderAllowedTime = function (sTime, eTime, tTime) {
              var _sTime = (0, _slicedToArray2["default"])(sTime, 2),
                startHour = _sTime[0],
                startMinute = _sTime[1];
              var _eTime = (0, _slicedToArray2["default"])(eTime, 2),
                endHour = _eTime[0],
                endMinute = _eTime[1];
              var _tTime$split$map = tTime.split(':').map(Number),
                _tTime$split$map2 = (0, _slicedToArray2["default"])(_tTime$split$map, 2),
                tHour = _tTime$split$map2[0],
                tMinute = _tTime$split$map2[1];
              var startDate = new Date();
              startDate.setHours(startHour);
              startDate.setMinutes(startMinute);
              startDate.setSeconds(0);
              var endDate = new Date();
              endDate.setHours(endHour);
              endDate.setMinutes(endMinute);
              endDate.setSeconds(0);
              var today = new Date();
              today.setHours(tHour);
              today.setMinutes(tMinute);
              today.setSeconds(0);
              return today.getTime() >= startDate.getTime() && today.getTime() <= endDate.getTime();
            }(startTime, endTime, todayTime);
            if (!isUnderAllowedTime) {
              _context.next = 26;
              break;
            }
            return _context.abrupt("return", clearInterval(id));
          case 26:
            _context.next = 28;
            return _appcenter["default"].auth.logout();
          case 28:
            _startTime = (0, _slicedToArray2["default"])(startTime, 2), startHour = _startTime[0], startMinute = _startTime[1];
            _endTime = (0, _slicedToArray2["default"])(endTime, 2), endHour = _endTime[0], endMinute = _endTime[1];
            setMessage({
              visible: true,
              title: 'Atenção - A sua conta tem nível de segurança ativado',
              description: /*#__PURE__*/_react["default"].createElement(_TimeBlockingMessage["default"], {
                startHour: startHour,
                startMinute: startMinute,
                endHour: endHour,
                endMinute: endMinute,
                timeZone: timeZone
              })
            });
          case 31:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), '1s', [storeState, auth, app]);
  (0, _index.useInterval)(function () {
    var state = _store.store.getState();
    if (JSON.stringify(state) !== JSON.stringify(storeState)) {
      setStoreState(state);
    }
  }, '1s');
  (0, _index.useAsyncEffect)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var _company$machineContr, _company$machineContr2;
    var licenses, company, user, hasMachineControl, machineControlLicense, userMachineName, allowedMachines, isFirstAccess, wasDisapproved, prevMachineName, currMachineName, userChangedMachine, _userCollection$doc$u, _userCollection$doc$u2, _yield$dokdriveInstal, _yield$dokdriveInstal2, currVersion;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          console.log('Checking dokdrive...');
          if (auth !== null && auth !== void 0 && auth.isAuthContextCreated) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          if (auth.authenticated) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return");
        case 5:
          licenses = auth.licenses || [];
          company = auth.company;
          user = auth.user;
          hasMachineControl = !!(company !== null && company !== void 0 && company.machineControl);
          if (hasMachineControl) {
            _context2.next = 11;
            break;
          }
          return _context2.abrupt("return");
        case 11:
          if ((_company$machineContr = company.machineControl[app]) !== null && _company$machineContr !== void 0 && _company$machineContr.enabled) {
            _context2.next = 13;
            break;
          }
          return _context2.abrupt("return");
        case 13:
          machineControlLicense = licenses.find(function (license) {
            return license.app === app && license.type === 'machine-control';
          });
          if (machineControlLicense) {
            _context2.next = 16;
            break;
          }
          return _context2.abrupt("return");
        case 16:
          if (['paid', 'free'].includes(machineControlLicense.status)) {
            _context2.next = 18;
            break;
          }
          return _context2.abrupt("return");
        case 18:
          if (!(user.companyAdmin && !!((_company$machineContr2 = company.machineControl[app]) !== null && _company$machineContr2 !== void 0 && _company$machineContr2.adminAccess))) {
            _context2.next = 20;
            break;
          }
          return _context2.abrupt("return");
        case 20:
          _context2.prev = 20;
          _context2.next = 23;
          return _dokdriveApi["default"].device.hostname();
        case 23:
          userMachineName = _context2.sent;
          allowedMachines = company.machineControl[app].machines || [];
          if (allowedMachines.includes(userMachineName)) {
            _context2.next = 43;
            break;
          }
          isFirstAccess = !user.accessControl || !user.accessControl[app];
          wasDisapproved = !isFirstAccess && user.accessControl[app].status === 'disapproved';
          prevMachineName = !isFirstAccess ? user.accessControl[app].machineName : '';
          currMachineName = userMachineName;
          userChangedMachine = !!prevMachineName && prevMachineName !== currMachineName;
          if (!(isFirstAccess || userChangedMachine)) {
            _context2.next = 37;
            break;
          }
          _context2.next = 34;
          return userCollection.doc(user.uid).update((_userCollection$doc$u = {}, (0, _defineProperty2["default"])(_userCollection$doc$u, "accessControl.".concat(app, ".machineName"), currMachineName), (0, _defineProperty2["default"])(_userCollection$doc$u, "accessControl.".concat(app, ".status"), 'waiting_approvation'), (0, _defineProperty2["default"])(_userCollection$doc$u, "accessControl.".concat(app, ".firstAccessAt"), new Date()), (0, _defineProperty2["default"])(_userCollection$doc$u, "accessControl.".concat(app, ".approvedAt"), ''), (0, _defineProperty2["default"])(_userCollection$doc$u, "accessControl.".concat(app, ".disapprovedAt"), ''), (0, _defineProperty2["default"])(_userCollection$doc$u, "accessControl.".concat(app, ".disapprovedAt"), ''), (0, _defineProperty2["default"])(_userCollection$doc$u, "accessControl.".concat(app, ".approvationRequestSent"), false), (0, _defineProperty2["default"])(_userCollection$doc$u, "accessControl.".concat(app, ".approvationRequestSentAt"), ''), _userCollection$doc$u));
        case 34:
          setMessage({
            visible: true,
            title: '⚠️ Atenção - Aprovação de Login em 24 Horas',
            description: userChangedMachine ? "Voc\xEA tentou acessar de um computador diferente, por isso, seu login passar\xE1 por aprova\xE7\xE3o novamente por 24 horas. \n\t\t\t\t\t\t\tAgradecemos pela compreens\xE3o." : "Seu login passar\xE1 por um per\xEDodo de aprova\xE7\xE3o de 24 horas. \n\t\t\t\t\t\t\tSeu acesso n\xE3o ser\xE1 bloqueado imediatamente. \n\t\t\t\t\t\t\tAgradecemos pela compreens\xE3o."
          });
          _context2.next = 41;
          break;
        case 37:
          if (!wasDisapproved) {
            _context2.next = 41;
            break;
          }
          _context2.next = 40;
          return _appcenter["default"].auth.logout();
        case 40:
          setMessage({
            visible: true,
            title: '⚠️ Atenção - Seu computador não está autorizado para fazer login',
            description: "Lamentamos, mas seu computador n\xE3o est\xE1 na lista de dispositivos permitidos \n\t\t\t\t\t\tpara acessar nosso site. Entre em contato com o suporte para resolver este \n\t\t\t\t\t\tproblema. Agradecemos pela compreens\xE3o."
          });
        case 41:
          _context2.next = 45;
          break;
        case 43:
          _context2.next = 45;
          return userCollection.doc(user.uid).update((_userCollection$doc$u2 = {}, (0, _defineProperty2["default"])(_userCollection$doc$u2, "accessControl.".concat(app, ".machineName"), userMachineName), (0, _defineProperty2["default"])(_userCollection$doc$u2, "accessControl.".concat(app, ".status"), 'approved'), (0, _defineProperty2["default"])(_userCollection$doc$u2, "accessControl.".concat(app, ".approvedAt"), new Date()), (0, _defineProperty2["default"])(_userCollection$doc$u2, "accessControl.".concat(app, ".disapprovedAt"), ''), _userCollection$doc$u2));
        case 45:
          _context2.next = 58;
          break;
        case 47:
          _context2.prev = 47;
          _context2.t0 = _context2["catch"](20);
          console.log('error', _context2.t0);
          _context2.next = 52;
          return dokdriveInstallerCollection.where('show', '==', true).orderBy('createdAt', 'desc').limit(1).get().then(function (v) {
            return v.docs.map(function (vv) {
              return vv.data();
            });
          });
        case 52:
          _yield$dokdriveInstal = _context2.sent;
          _yield$dokdriveInstal2 = (0, _slicedToArray2["default"])(_yield$dokdriveInstal, 1);
          currVersion = _yield$dokdriveInstal2[0];
          setMessage({
            visible: true,
            title: 'Atenção - Requisito de segurança solicitado',
            description: /*#__PURE__*/_react["default"].createElement(_SecurityRequirementAlert["default"], {
              url: currVersion.url
            }),
            buttons: [{
              cancel: true,
              text: 'Fechar',
              onClick: function onClick() {
                return setMessage(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, {
                    visible: false
                  });
                });
              }
            }, {
              text: 'Baixar Requisito de Segurança',
              onClick: function onClick() {
                var a = document.createElement('a');
                a.setAttribute('href', currVersion.url);
                a.click();
              }
            }]
          });
          _context2.next = 58;
          return _appcenter["default"].auth.logout();
        case 58:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[20, 47]]);
  })), [storeState, auth, app]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children, /*#__PURE__*/_react["default"].createElement(_CelebrationMessages["default"], null), /*#__PURE__*/_react["default"].createElement(_Message["default"], (0, _extends2["default"])({}, message, {
    hide: function hide() {
      return setMessage(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          visible: false
        });
      });
    }
  })));
}
var _default = Scripts;
exports["default"] = _default;